export const getDateTimeFormatString = (type: 'date' | 'datetime') => {
	const locale = localStorage.getItem('locale') || localStorage.getItem('defaultLanguage');

	const formatParts = new Intl.DateTimeFormat(locale, {
		year: 'numeric',
		month: 'numeric',
		day: 'numeric',
		...(type === 'datetime'
			? {
					hour: 'numeric',
					minute: 'numeric'
			  }
			: {})
	}).formatToParts(new Date());

	const formatMap = {
		year: 'YYYY',
		month: 'MM',
		day: 'DD',
		hour: 'hh',
		minute: 'mm',
		dayPeriod: 'AM/PM'
	};

	return formatParts.map(part => formatMap[part.type] || part.value).join('');
};
